<div>
  <gate-impersonation-status />
  <gate-hero />
  <div class="flex min-w-0">
    <!-- Sidebar -->
    @if (sidebarOpen) {
    <div class="fixed inset-0 z-20 transition-opacity bg-black opacity-50 lg:hidden" (click)="toggleSidebar()"></div>
    }

    <div
       [ngClass]="{ 'translate-x-0 ease-out': sidebarOpen, '-translate-x-full ease-in': !sidebarOpen, 'lg:!top-16 lg:h-[94%]':isImpersonatingAsAcpUser(),'top-sticky lg:h-[98%]':!isImpersonatingAsAcpUser() }"
       [class.lg:hidden]="!desktopSidebarOpen()"
       class="lg:sticky fixed inset-y-0 left-0 lg:z-0 z-50 lg:w-[18em] w-[min(20rem,85vw)] h-[100dvh] max-h-[100dvh] overflow-hidden transition duration-300 transform lg:translate-x-0 lg:static lg:inset-0 lg:pl-4 pl-0 md:mt-4 mt-0"
      >
      <gate-navigation
        [customer]="customer"
        [currentCustomerName]="currentCustomerName"
        [currentCustomerId]="currentCustomerId"
        [isCustomerLoading]="isCustomerLoading"
        [customersMenuItem]="customersMenuItem"
        [preferredCustomerLoadingId]="preferredCustomerLoadingId"
        (onClickMenu)="onClickMenu()"
        (customerSelected)="switchCustomer($event)"
        (preferredCustomerSelected)="setPreferredCustomer($event.customerId)"></gate-navigation>
    </div>

    <!-- Main content -->
    <div class="flex min-w-0 flex-col flex-1 lg:p-4 p-2 h-full">
      <!-- Your main content -->
      <main class="min-w-0 flex-1 mb-4">
        <div class="lg:hidden sticky top-2 lg:top-6" [ngClass]="{ 'z-30': !sidebarOpen, 'z-10': sidebarOpen, 'top-17':isImpersonatingAsAcpUser() }">
          <div class="absolute inset-x-0 -top-2  lg:-top-4 h-4 lg:h-6 bg-[var(--background-color)] pointer-events-none"></div>
          <div class="relative bg-[var(--background-color)]">
          <p-panel [showHeader]="false" class="navigation-panel">
            <div class="flex justify-between">
              <div class="flex items-center">
                <a [routerLink]="['/' + routes.homePath]" routerLinkActive="router-link-active">
                  <img
                    src="https://www.acp-gruppe.com/hs-fs/hubfs/acp_logo_rgb_small.png?width=66&height=66&name=acp_logo_rgb_small.png"
                    alt="ACP Logo" class="size-12" />
                </a>
                <h1 class="text-lg font-bold ml-4">GATE</h1>
              </div>
              <a (click)="toggleSidebar()" class="flex text-gray-500 focus:outline-none">
                <i class="pi pi-align-justify m-auto border rounded-full p-3"></i>
              </a>
            </div>
          </p-panel>
          <gate-breadcrumb class="block w-full min-w-0" />
          </div>
        </div>
        <div class="col-start-2 col-span-4 sticky top-2 lg:top-4 z-30 lg:block hidden" [ngClass]="{'!top-16':isImpersonatingAsAcpUser() }">
          <div class="absolute inset-x-0 -top-2 h-4 lg:h-6 bg-[var(--background-color)] pointer-events-none lg:-top-4"></div>
          <div class="relative bg-[var(--background-color)] pb-3">
            <gate-header 
            [customer]="customer"
            [currentCustomerName]="currentCustomerName"
            [isLoading]="isCustomerLoading"
            [customersMenuItem]="customersMenuItem"
            [preferredCustomerLoadingId]="preferredCustomerLoadingId"
            (customerSelected)="switchCustomer($event)"
            (preferredCustomerSelected)="setPreferredCustomer($event.customerId)"
            ></gate-header>
          </div>
        </div>
        <div class="col-start-2 col-span-4" [ngClass]="{'lg:mt-12 mt-16':isImpersonatingAsAcpUser(), 'mt-2':!isImpersonatingAsAcpUser() }">
          <router-outlet />
        </div>
        <div class="col-start-1 col-span-5 row-start-5 fixed bottom-0"></div>
      </main>
      <!-- Add Toast for alert -->
      <p-toast />
    </div>
    
  </div>
  <p-speeddial [model]="speedDialMenu" direction="up" [pt]="{root:'z-10', list:'w-full rounded-md !flex-col !gap-0 mb-3',item:'w-full'}"
    [style]="{ position: 'fixed', right: '1.5rem', bottom: '1.5rem' }">
    <ng-template #button let-toggleCallback="toggleCallback">
        <div class="feedback-icon" (click)="toggleCallback($event)">
          <img src="assets/icons/communication_w_1000px_rgb.png" alt="feedback" srcset="">
        </div>
    </ng-template>
     <ng-template #item let-item let-toggleCallback="toggleCallback">
        <div class="w-full flex items-center gap-2 py-2 px-4 cursor-pointer"
            (click)="toggleCallback($event, item)">
            <img [src]="item.icon" alt="{{ item.label }}" class="w-5 h-5"/>
            <span>
                {{ item.label |translate}}
            </span>
        </div>
    </ng-template>
    </p-speeddial>
</div>
<gate-footer/>
